import { useMediaQuery } from 'react-responsive';

export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({
    query: '(max-width:1100px)',
  });
  return <>{isMobile && children}</>;
};

export const Others = ({ children }) => {
  const isOthers = useMediaQuery({
    query: '(min-width:1101px)',
  });
  return <>{isOthers && children}</>;
};
